var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDashboardSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.5C3.34315 14.5 2 15.8431 2 17.5C2 18.0523 2.44772 18.5 3 18.5H13C13.5523 18.5 14 18.0523 14 17.5C14 15.8431 12.6569 14.5 11 14.5H5ZM0 17.5C0 14.7386 2.23858 12.5 5 12.5H11C13.7614 12.5 16 14.7386 16 17.5C16 19.1569 14.6569 20.5 13 20.5H3C1.34315 20.5 0 19.1569 0 17.5Z",
    fill: "#FF7228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.5C6.3431 2.5 5 3.84315 5 5.5C5 7.15685 6.3431 8.5 8 8.5C9.6569 8.5 11 7.15685 11 5.5C11 3.84315 9.6569 2.5 8 2.5ZM3 5.5C3 2.73858 5.23858 0.5 8 0.5C10.7614 0.5 13 2.73858 13 5.5C13 8.26142 10.7614 10.5 8 10.5C5.23858 10.5 3 8.26142 3 5.5Z",
    fill: "#FF7228"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDashboardSelected);
export default __webpack_public_path__ + "static/media/profile-dashboard-selected.84551446e536bb34a38433e148db6685.svg";
export { ForwardRef as ReactComponent };